import styled from "styled-components";
import theme from "../../Styles/theme";

export const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
`;

export const Title = styled.h1`
  font-size: max(1.2vw, 12px);
  color: ${theme.colors.dark};
`;

export const Label = styled.label`
  font-size: max(1vw, 10px);
  color: ${theme.colors.dark};
  display: flex;
  flex-direction: column;
  width: 90%;
`;

export const Input = styled.input`
  font-size: max(1vw, 10px);
  color: ${theme.colors.dark};
  background-color: ${theme.colors.light};
  border-radius: 0.25rem;
  border: none;
  padding: 1vw 0.5vh;
  width: 90%;
`;

export const LabelDate = styled.label`
  font-size: max(1vw, 10px);
  color: ${theme.colors.dark};
  display: flex;
  flex-direction: column;
`;

export const DateSelectorContainer = styled.div`
  font-size: max(0.8vw, 8px);
  color: ${theme.colors.dark};

  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  
  margin-top: 2vh;
`;

export const DivButtons = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  width: 80%;
  margin-top: 2vh;
`;

export const Button = styled.button`
  background-color: ${theme.colors.darkGrey};
  color: ${theme.colors.dark};
  font-size: max(1vw, 10px);
  padding: 0.5vh 1vw;
  border-radius: 0.25rem;
  min-width: 20%;
`;
